import FormTemplateModal from "./FormTemplateModal";
export default FormTemplateModal;
